import styled, { CSSProperties } from 'styled-components';

type Props = {
  color?: 'green' | 'primary' | 'purple' | 'pink';
};

export const Check = styled.div<Props>`
  position: relative;
  display: block;
  justify-content: space-between;
  width: 20px;
  height: 20px;
  transform: rotate(-45deg) translateY(-3px) translateX(3px);

  &:before {
    content: '';
    display: inline-block;
    width: 2px;
    height: 10px;
    border-radius: ${({ theme }) => theme.radii.rounded};

    ${({ theme, color = 'primary' }) => {
      switch (color) {
        case 'green':
          return {
            backgroundColor: theme.backgroundColors.green,
          };
        case 'primary':
          return {
            backgroundColor: theme.backgroundColors.primary,
          };
        case 'purple':
          return {
            backgroundColor: theme.backgroundColors.purple,
          };
        case 'pink':
          return {
            backgroundColor: theme.backgroundColors.secondary,
          };
      }
    }}
  }

  &:after {
    content: '';
    display: inline-block;
    width: 14px;
    height: 2px;
    border-radius: ${({ theme }) =>
      `0 ${theme.radii.rounded} ${theme.radii.rounded} 0`};

    ${({ theme, color = 'primary' }) => {
      switch (color) {
        case 'green':
          return {
            backgroundColor: theme.backgroundColors.green,
          };
        case 'primary':
          return {
            backgroundColor: theme.backgroundColors.primary,
          };
        case 'purple':
          return {
            backgroundColor: theme.backgroundColors.purple,
          };
        case 'pink':
          return {
            backgroundColor: theme.backgroundColors.secondary,
          };
      }
    }}
  }
`;
